import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Finnaij: generic "re-render me on variant change" element. Liquid renders the content for
 * the selected variant; when the shopper picks another variant, the variant picker fetches
 * the re-rendered section and this element morphs itself from the matching id in that HTML.
 * Used by blocks/add-to-cart-price.liquid.
 *
 * @extends {Component}
 */
class FinnaijVariantSync extends Component {
  /** @type {HTMLElement | null} */
  #target = null;

  connectedCallback() {
    super.connectedCallback();
    this.#target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#target = null;
  }

  /**
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.html || !this.id) return;
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const updated = detail.html.getElementById(this.id);
        if (updated instanceof HTMLElement) morph(this, updated);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[finnaij-variant-sync] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('finnaij-variant-sync')) {
  customElements.define('finnaij-variant-sync', FinnaijVariantSync);
}
